import { useQuery } from '@apollo/client'
import { y00tsUniqueWallets } from 'apollo/client'
import gql from 'graphql-tag'
import { useMemo } from 'react'
import { notEmpty } from 'utils'

export const QUERY_Y00TS_STATS = gql`
  query records {
    records {
        date_time,
        unique_wallets,
        cumulative_unique_wallets
    }
  }
`

interface y00tsStatsData {
    records: {
        date_time: String
        unique_wallets: Number
        cumulative_unique_wallets: Number
    }[]
}

/**
 * Fetch matic current price
 */

export function useZettaUniqueWallets(): {
    loading: boolean
    error: boolean,
    records: {
        date_time: String
        unique_wallets: Number
        cumulative_unique_wallets: Number
    }[] | undefined
} {
    const { loading, error, data } = useQuery<y00tsStatsData>(QUERY_Y00TS_STATS, {
        client: y00tsUniqueWallets,
        fetchPolicy: 'cache-first',
    })
    const formattedData = useMemo(() => {
        if (data) {
            return data.records
                .map((p) => {
                    return {
                        date_time: p.date_time,
                        unique_wallets: p.unique_wallets,
                        cumulative_unique_wallets: p.cumulative_unique_wallets,
                    }
                })
                .filter(notEmpty)
        } else {
            return undefined
        }
    }, [data])

    return {
        loading: loading,
        error: Boolean(error),
        records: formattedData,
    }
}
